<template>
  <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Bari cheez ke andar chhoti cheezein</h2>
      <p class="text-sm text-slate-600">Yahan dekho ke package ke andar module hota hai aur module ke andar function hota hai.</p>
    </div>

    <div class="mt-4 rounded-2xl bg-slate-950 p-4 text-xs leading-7 text-slate-100">
      <code>stdlib/
|-- random
|   |-- randint()
|-- datetime
    |-- now()</code>
    </div>
  </section>
</template>
